// removed by extract-text-webpack-plugin
module.exports = {"title":"require-user-on-guest-list__title__1SVPC","sub-title":"require-user-on-guest-list__sub-title__3Rt0Q"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/require-user-on-guest-list.scss
// module id = 1243
// module chunks = 1